import React from "react";
import {  FaArrowRight, FaArrowDown, FaEdit, FaTrash, FaShareAlt, FaCopy, FaArrowsAlt, FaFolderPlus, FaCheckCircle, FaUpload, FaFileSignature, FaMinusCircle, FaStar  } from "react-icons/fa";

const ActionsMenu = ({selectedItems, selectionMode, actionMenu, handleAction, exitSelectionMode, activeTab }) => {
  if (!actionMenu) return null;
  
  const isEditable = (fileName) => {
    const ext = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
  
    switch (ext) {
      case ".pdf":
        return true;
      case ".doc":
      case ".docx":
        return true;
      case ".xls":
      case ".xlsx":
        return true;
      case ".ppt":
      case ".pptx":
        return true;
      default:
        return false;
    }
  };

  return (
    <div>      
      {/* Selection options */}     
      {selectionMode ? (
        <div className="flex flex-wrap justify-between items-center mb-4 gap-4 sm:flex-col sm:gap-2 w-full">
          <span className="font-semibold text-lg text-gray-800 dark:text-gray-200 truncate max-w-full sm:max-w-[90%]">
            {selectedItems.length} item{selectedItems.length > 1 ? "s" : ""} selected
          </span>
          <button
            onClick={exitSelectionMode}
            className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition w-full sm:w-auto text-center truncate max-w-full sm:max-w-[200px]"
          >
            Cancel Selection
          </button>
        </div>
      ) : (
        <>
        </>
      )}

      <ul className="space-y-2">
        {!actionMenu.selectionMode && actionMenu.item && actionMenu.item.type === "file" && isEditable(actionMenu.item.name) && (
          <li>
            <button
              onClick={() => handleAction(actionMenu, 'edit')}
              className={`w-full flex items-center space-x-2 px-3 py-2 rounded transition ${
                'bg-blue-500 hover:bg-blue-600 dark:bg-blue-700 hover:dark:bg-blue-600 text-white dark:text-gray-200'
              }`}
            >
              <FaFileSignature  />
              <span>Edit</span>
            </button>
          </li>
        )}
        {!actionMenu.selectionMode && actionMenu.item && actionMenu.item.type === "dir" && (
          <li>
            <button
              onClick={() => handleAction(actionMenu, 'open')}
              className={`w-full flex items-center space-x-2 px-3 py-2 rounded transition ${
                'bg-blue-500 hover:bg-blue-600 dark:bg-blue-700 hover:dark:bg-blue-600 text-white dark:text-gray-200'
              }`}
            >
              <FaArrowRight />
              <span>Open</span>
            </button>
          </li>
        )}
        {!actionMenu.selectionMode && actionMenu.item && (
          <li>
            <button
              onClick={() => handleAction(actionMenu, 'download')}
              className={`w-full flex items-center space-x-2 px-3 py-2 rounded transition ${
                'bg-teal-500 hover:bg-teal-600 dark:bg-teal-700 hover:dark:bg-teal-600 text-white dark:text-gray-200'
              }`}
            >
              <FaArrowDown />
              <span>Download</span>
            </button>
          </li>
        )}
        {!actionMenu.selectionMode && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <li>
            <button
              onClick={() => handleAction(actionMenu, 'select')}
              className={`w-full flex items-center space-x-2 px-3 py-2 rounded transition ${
                'bg-amber-500 hover:bg-amber-600 dark:bg-amber-700 hover:dark:bg-amber-600 text-white dark:text-gray-200'
              }`}
            >
              <FaCheckCircle />
              <span>Select</span>
            </button>
          </li>
        )}
        {!actionMenu.selectionMode && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <li>
            <button
              onClick={() => handleAction(actionMenu, 'create')}
              className={`w-full flex items-center space-x-2 px-3 py-2 rounded transition ${
                'bg-green-500 hover:bg-green-600 dark:bg-green-700 hover:dark:bg-green-600 text-white dark:text-gray-200'
              }`}
            >
              <FaFolderPlus />
              <span>Create Folder</span>
            </button>
          </li>
        )}
        {!actionMenu.selectionMode && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <li>
            <button
              onClick={() => handleAction(actionMenu, 'upload')}
              className={`w-full flex items-center space-x-2 px-3 py-2 rounded transition ${
                'bg-purple-500 hover:bg-purple-600 dark:bg-purple-700 hover:dark:bg-purple-600 text-white dark:text-gray-200'
              }`}
            >
              <FaUpload />
              <span>Upload</span>
            </button>
          </li>
        )}
        {actionMenu.item && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <li>
            <button            
              onClick={() => handleAction(actionMenu, "copy")}
              className={`w-full flex items-center space-x-2 px-3 py-2 rounded transition ${
                'bg-indigo-500 hover:bg-indigo-600 dark:bg-indigo-700 hover:dark:bg-indigo-600 text-white dark:text-gray-200'
              }`}
            >
              <FaCopy />
              <span>Copy</span>
            </button>
          </li>
        )}
        {!actionMenu.selectionMode && actionMenu.item && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <li>
            <button 
              onClick={() => handleAction(actionMenu, "move")}
              className={`w-full flex items-center space-x-2 px-3 py-2 rounded transition ${
                'bg-cyan-500 hover:bg-cyan-600 dark:bg-cyan-700 hover:dark:bg-cyan-600 text-white dark:text-gray-200'
              }`}
            >
              <FaArrowsAlt />
              <span>Move</span>
            </button>
          </li>
        )}
        {!actionMenu.selectionMode && actionMenu.item && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <li>
            <button
              onClick={() => handleAction(actionMenu, 'rename')}
              className={`w-full flex items-center space-x-2 px-3 py-2 rounded transition ${
                'bg-yellow-500 hover:bg-yellow-600 dark:bg-yellow-700 hover:dark:bg-yellow-600 text-white dark:text-gray-200'
              }`}
            >
              <FaEdit />
              <span>Rename</span>
            </button>
          </li>
        )}
        {!actionMenu.selectionMode && actionMenu.item && !actionMenu.item.favorite && activeTab !== 'shared' && (
          <li>
            <button
              onClick={() => handleAction(actionMenu, 'favorite')}
              className={`w-full flex items-center space-x-2 px-3 py-2 rounded transition ${
                'bg-orange-500 hover:bg-orange-600 dark:bg-orange-700 hover:dark:bg-orange-600 text-white dark:text-gray-200'
              }`}
            >
              <FaStar />
              <span>Favorite</span>
            </button>
          </li>
        )}
        {!actionMenu.selectionMode && actionMenu.item && actionMenu.item.favorite && activeTab !== 'shared' && (
          <li>
            <button
              onClick={() => handleAction(actionMenu, 'favorite')}
              className={`w-full flex items-center space-x-2 px-3 py-2 rounded transition ${
                'bg-orange-500 hover:bg-orange-600 dark:bg-orange-700 hover:dark:bg-orange-600 text-white dark:text-gray-200'
              }`}
            >
              <FaMinusCircle />
              <span>Unfavorite</span>
            </button>
          </li>
        )}
        {!actionMenu.selectionMode && actionMenu.item && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <li>
            <button
              onClick={() => handleAction(actionMenu, 'sharewithuser')}
              className={`w-full flex items-center space-x-2 px-3 py-2 rounded transition ${
                'bg-orange-500 hover:bg-orange-600 dark:bg-orange-700 hover:dark:bg-orange-600 text-white dark:text-gray-200'
              }`}
            >
              <FaShareAlt />
              <span>Share With</span>
            </button>
          </li>
        )}
        {!actionMenu.selectionMode && actionMenu.item && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <li>
            <button
              onClick={() => handleAction(actionMenu, 'share')}
              className={`w-full flex items-center space-x-2 px-3 py-2 rounded transition ${
                'bg-orange-500 hover:bg-orange-600 dark:bg-orange-700 hover:dark:bg-orange-600 text-white dark:text-gray-200'
              }`}
            >
              <FaShareAlt />
              <span>Share</span>
            </button>
          </li>
        )}
        {actionMenu.item && activeTab !== 'shared' && activeTab !== 'favorites' && (
          <li>
            <button
              onClick={() => handleAction(actionMenu, 'delete')}
              className={`w-full flex items-center space-x-2 px-3 py-2 rounded transition ${
                'bg-red-500 hover:bg-red-600 dark:bg-red-700 hover:dark:bg-red-600 text-white dark:text-gray-200'
              }`}
            >
              <FaTrash />
              <span>Delete</span>
            </button>      
          </li>  
        )}
      </ul>
    </div>
  );
};

export default ActionsMenu;